import { changeFavicon } from "../../util";
import { useLocation } from "react-router-dom";
import GradiousLogo from "../../Svg/GradiousLogo";
import AlertContext from "../../context/AlertContext";
import React, { useContext, useEffect, useState } from "react";

const CompanyLogo = ({ hideCompanyName, component }) => {
  const { isAdmin } = useContext(AlertContext);

  const { pathname } = useLocation();

  const [logoComponent, setLogoComponent] = useState(null);

  useEffect(() => {
    if (pathname !== "/batch" && !isAdmin) {
      if (
        pathname !== "/company" &&
        localStorage.getItem("favicon") &&
        localStorage.getItem("favicon") !== "" &&
        localStorage.getItem("favicon") !== "null" &&
        parseInt(localStorage.getItem("companyId")) !== 1
      ) {
        changeFavicon(localStorage.getItem("favicon"));
      } else {
        changeFavicon("/favicon.ico");
      }

      setLogoComponent(
        pathname !== "/company" &&
          localStorage.getItem("logo") &&
          localStorage.getItem("logo") !== "" &&
          localStorage.getItem("logo") !== "null" &&
          parseInt(localStorage.getItem("companyId")) !== 1 ? (component !== "companyheader" && component !== "leftNav" ? <>
          <div className="companyLogoContainer">
            <img
              alt="logo"
              className="companyLogo"
              src={localStorage.getItem("logo")}
            />

            <div
              className={
                component === "leftNav"
                  ? "companyLogoTextOnLeftNav"
                  : "companyLogoText"
              }
            >
              Powered by Gradious
            </div>
          </div>
          </> : <></>
        ) : (
          <GradiousLogo
            component={component}
            hideCompanyName={hideCompanyName}
          />
        )
      );
    } else {
      setLogoComponent(
        <GradiousLogo hideCompanyName={hideCompanyName} component={component} />
      );
    }
  }, [isAdmin, pathname, component, hideCompanyName]);

  return logoComponent;
};

export default CompanyLogo;
